import { GetMethod, PostMethod } from '../../serviceHelper';

const getMethods = (service: 'main', controller: 'PermissionGroup') => ({
	GetAll: new GetMethod<any, any>({
		service,
		controller,
		method: 'GetAll'
	}),
	Create: new PostMethod<any, any>({
		service,
		controller,
		method: 'Create'
	}),
	Delete: new PostMethod<any, any>({
		service,
		controller,
		method: 'Delete'
	}),
	Rename: new PostMethod<any, any>({
		service,
		controller,
		method: 'Rename'
	}),
	AddMembers: new PostMethod<any, any>({
		service,
		controller,
		method: 'AddMembers'
	}),
	AddMemberOfs: new PostMethod<any, any>({
		service,
		controller,
		method: 'AddMemberOfs'
	}),
	RemoveMember: new PostMethod<any, any>({
		service,
		controller,
		method: 'RemoveMember'
	}),
	SearchMembers: new PostMethod<any, any>({
		service,
		controller,
		method: 'SearchMembers'
	}),
	GetMemberInfoDetails: new PostMethod<any, any>({
		service,
		controller,
		method: 'GetMemberInfoDetails'
	}),
	GetMemberInfoDetailsByLoadOptions: new PostMethod<any, any>({
		service,
		controller,
		method: 'GetMemberInfoDetailsByLoadOptions'
	}),
	GetAllOfObject: new PostMethod<any, any>({
		service,
		controller,
		method: 'GetAllOfObject'
	}),
	GetSuggestions: new PostMethod<any, any>({
		service,
		controller,
		method: 'GetSuggestions'
	}),
	BindObject: new PostMethod<any, any>({
		service,
		controller,
		method: 'BindObject'
	}),
	UnbindObject: new PostMethod<any, any>({
		service,
		controller,
		method: 'UnbindObject'
	})
});

export { getMethods };
